import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchFournisseurAdministration } from 'utils/fetchers';
import { patchFournisseur } from 'store/administration/administrationActions';
import AdministrationFournisseur from './AdministrationFournisseur';

class AdministrationFournisseurContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            fournisseur: null
        };
    }

    async componentDidMount() {
        const { id } = this.props;

        var fournisseur = await this.props.fetchFournisseurAdministration(id);
        
        console.log("componentDidMount fournisseur ", fournisseur);

        this.setState({fournisseur : fournisseur});
    }
           
    handleChange = (event) => {

        let newFournisseur = this.state.fournisseur;
        
        if (event.target.name === 'autoriseSAVPlateformeLogistique') {
            newFournisseur.autoriseSAVPlateformeLogistique = !newFournisseur.autoriseSAVPlateformeLogistique;
        }

        if (event.target.name === 'autoriseSAV') {
            newFournisseur.autoriseSAV = !newFournisseur.autoriseSAV;
        }
               
        this.setState({ ...this.state, fournisseur: newFournisseur });
    };

    handleClickSave = async () => {
        await this.props.patchFournisseur(this.state.fournisseur);
    };

    render() {
        const { fournisseur } = this.state;

        return (
            <AdministrationFournisseur
                fournisseur={fournisseur}
                isPatching={false}

                onChange={this.handleChange}
                onClickSave={this.handleClickSave}         

            />);
    }
}

AdministrationFournisseurContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = state => ({
    //isLoading: state.administration.causesPrincipales.isLoading,
    //isPatching: state.administration.causesPrincipales.isPatching,
    //causesPrincipales: state.administration.causesPrincipales.items
});

const mapDispatchToProps = dispatch => ({
    fetchFournisseurAdministration: (fournisseurId) => dispatch(fetchFournisseurAdministration(fournisseurId)),
    patchFournisseur: (fournisseur) => dispatch(patchFournisseur(fournisseur))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationFournisseurContainer);